import fetch from 'isomorphic-fetch';

export default function fetchJson(...params) {
  return fetch(...params)
    .then(async (response) => {
      if (response.status === 204 || response.status === 202) {
        return {json: '', response};
      }
      const json = await response.json();
      if (!response.ok && json.type !== 'account-block') {
        throw Object.assign(new Error(), {json, response});
      }
      return {json, response};
    });
}



// WEBPACK FOOTER //
// ./spa/fetch-json.jsx